import React from 'react';
import { Popover, Button } from 'antd';
import KoStaicMembers from 'packages/staticMember';
import styles from './sharedWith.module.scss';

export default function SharedWithUsers({ data }) {
  let users = data?.users || [];
  const visibleUsers = users.slice(0, 1) || [];
  const hiddenUsers = users.slice(1) || [];

  const renderPopoverContent = () => (
    <div className={styles.popoverContent}>
      {hiddenUsers.map((user, index) => (
        <KoStaicMembers key={`user-${index}`} data={user?.profile} />
      ))}
    </div>
  );

  return (
    <div className={styles.wrapper}>
      {visibleUsers.map((user, index) => (
        <KoStaicMembers key={`visible-user-${index}`} data={user?.profile} />
      ))}

      {( hiddenUsers.length > 0) && (
        <Popover autoAdjustOverflow className={styles.popover} content={renderPopoverContent()}>
          <Button type="link" className={styles.moreButton}>
            +{hiddenUsers.length} more
          </Button>
        </Popover>
      )}
    </div>
  );
}
